import { render, staticRenderFns } from "./CalendarSettingsModal.vue?vue&type=template&id=003cf4b0&scoped=true"
import script from "./CalendarSettingsModal.vue?vue&type=script&lang=js"
export * from "./CalendarSettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003cf4b0",
  null
  
)

export default component.exports